type PageHeaderProps = {
  eyebrow?: string;
  title: string;
  children?: React.ReactNode;
};

export function PageHeader({ eyebrow, title, children }: PageHeaderProps) {
  return (
    <section className="page-header">
      <div className="container narrow">
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <h1>{title}</h1>
        {children ? <p className="lead">{children}</p> : null}
      </div>
    </section>
  );
}
